import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export default function SavePlantDialog({ analysis, open, onOpenChange, onSaved }) {
  const [plants, setPlants] = useState([]);
  const [mode, setMode] = useState("new");
  const [plantId, setPlantId] = useState("");
  const [form, setForm] = useState({ name: "", cultivation: "", location: "", variety: "" });
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    api.get("/plants").then(({ data }) => {
      setPlants(data);
      if (data.length) setPlantId(data[0].id);
    });
  }, [open]);

  const save = async () => {
    const sp = analysis.species || {};
    const body = mode === "existing" ? { plant_id: plantId } : {
      new_plant: { ...form, name: form.name || sp.common_name || "La mia pianta", species_common: sp.common_name, species_botanical: sp.botanical_name, cultivation: form.cultivation || null },
    };
    try {
      const { data } = await api.post(`/analyses/${analysis.id}/attach`, body);
      toast.success("Analisi salvata nello storico della pianta");
      onOpenChange(false);
      onSaved?.();
      navigate(`/piante/${data.plant_id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm bg-[#f8f3e9]" data-testid="save-plant-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl text-[#0D2517]">Salva in Le mie piante</DialogTitle></DialogHeader>
        {plants.length > 0 && (
          <div className="grid grid-cols-2 gap-2">
            <button onClick={() => setMode("new")} className={`chip ${mode === "new" ? "chip-on" : ""}`} data-testid="save-mode-new">Nuova pianta</button>
            <button onClick={() => setMode("existing")} className={`chip ${mode === "existing" ? "chip-on" : ""}`} data-testid="save-mode-existing">Pianta esistente</button>
          </div>
        )}
        {mode === "existing" ? (
          <select className="field" value={plantId} onChange={(e) => setPlantId(e.target.value)} data-testid="save-existing-select">
            {plants.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        ) : (
          <div className="space-y-2">
            <input className="field" placeholder="Nome (es. Limone del terrazzo)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="save-plant-name" />
            <div className="grid grid-cols-2 gap-2">
              {[["vaso", "In vaso"], ["piena_terra", "Piena terra"]].map(([v, l]) => (
                <button key={v} onClick={() => setForm({ ...form, cultivation: v })} className={`chip ${form.cultivation === v ? "chip-on" : ""}`} data-testid={`save-cultivation-${v}`}>{l}</button>
              ))}
            </div>
            <input className="field" placeholder="Varietà (se la conosci)" value={form.variety} onChange={(e) => setForm({ ...form, variety: e.target.value })} data-testid="save-plant-variety" />
            <input className="field" placeholder="Località" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} data-testid="save-plant-location" />
          </div>
        )}
        <button onClick={save} className="btn-primary w-full" data-testid="save-plant-confirm"><Leaf size={16} /> SALVA</button>
      </DialogContent>
    </Dialog>
  );
}
